export default "__VITE_ASSET__CRjV_buS__"